import { render, staticRenderFns } from "./SideFormContainer.vue?vue&type=template&id=0a26d6e2"
import script from "./SideFormContainer.vue?vue&type=script&lang=js"
export * from "./SideFormContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports